import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { NeuButton } from "../../components/neu/Neu";
import { isNative } from "../../native/capacitor";
import { registerPush } from "../../native/pushRegister";
import { PushTestButton } from "./PushTestButton";

// صف تفعيل/تشخيص الإشعارات للنسخة الأصلية (iOS/Android): يطلب الإذن، يسجّل توكن native، ويختبر الوصول.
export const NativePushRow = () => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const [result, setResult] = useState(null);
  if (!isNative()) return null;

  const enable = async () => {
    setBusy(true);
    try {
      const res = await registerPush();
      setResult(res);
      if (res.registered) {
        toast.success(t("push.enabled"));
        setReloadKey((k) => k + 1);
      } else {
        toast.error(t(`push.${res.reason || "error"}`, t("push.denied")));
      }
    } catch (e) {
      setResult({ registered: false, reason: "exception", error: String(e?.message || e).slice(0, 140) });
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="neu-in rounded-2xl p-4" data-testid="native-push-row">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <BellRing className="h-4 w-4 text-primary" />
          <div>
            <p className="text-sm font-bold">{t("push.title")}</p>
            <p className="text-xs text-muted-foreground" data-testid="native-push-hint">{t("push.nativeHint")}</p>
          </div>
        </div>
        <NeuButton variant="primary" className="w-full justify-center px-4 py-2.5 text-xs sm:w-auto sm:px-5"
          disabled={busy} data-testid="native-push-enable" onClick={enable}>
          {t("push.enable")}
        </NeuButton>
      </div>
      <PushTestButton reloadKey={reloadKey} />
      {result ? (
        <pre className="mt-2 overflow-x-auto rounded-xl bg-muted/40 p-2 text-[11px] leading-5 text-muted-foreground" dir="ltr" data-testid="native-push-diag">
          {result.registered
            ? `OK registered · ${result.token || ""}`
            : `FAIL · reason=${result.reason || "?"}${result.error ? " · " + result.error : ""}`}
        </pre>
      ) : null}
    </div>
  );
};
